import React from 'react';
import SignupPage from './SignupPage';

export default function LoginPage() {
  return <SignupPage />;
}
